// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".login-page[data-v-16d8eba4] {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.panel[data-v-16d8eba4] {\n  min-width: 400px;\n}\n.panel-heading[data-v-16d8eba4] {\n  text-align: center;\n  font-size: 24px;\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n.logo[data-v-16d8eba4] {\n  width: 200px;\n  height: auto;\n  margin-bottom: 20px;\n}\n.alert[data-v-16d8eba4] {\n  margin-bottom: 20px;\n}\n[data-v-16d8eba4] .el-alert__title {\n  font-size: 14px;\n}", ""]);
// Exports
module.exports = exports;
